// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__0qRYA","title":"style__title__zrInD","description":"style__description__t1+yu","component":"style__component__rimp3"};